import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=0805d630&scoped=true"
import script from "./MenuEdit.vue?vue&type=script&lang=js"
export * from "./MenuEdit.vue?vue&type=script&lang=js"
import style0 from "./MenuEdit.vue?vue&type=style&index=0&id=0805d630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805d630",
  null
  
)

export default component.exports